import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import deleteimage from '../../assets/delete.png'

const DeleteModal = ({ open, handleDeleteClose, message, handleOnClick, error
}) => {
  return (
    <Modal
      open={open}
      onClose={handleDeleteClose}
      aria-labelledby="success-modal-title"
      aria-describedby="success-modal-description"
      sx={{ boxShadow: '-14px 30px 20px 0px #0000000D', borderRadius: '10px' }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          textAlign: 'center',
        }}
      >
        <img src={deleteimage} alt='success' />
        <Typography id="success-modal-description" variant="body1" my={2}>
          {message}
        </Typography>
        {error && (
          <Typography color="error" variant='body2' mt={1}>{error}</Typography>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 4 }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              borderRadius: '7px',
              backgroundColor: '#01A0E2',
              color: '#fff',
              width: '90px',
              textTransform: 'none'
            }}
            onClick={handleOnClick}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            sx={{
              borderRadius: '7px',
              borderColor: '#01A0E2',
              color: '#000',
              width: '90px',
              textTransform: 'none'
            }}
            onClick={handleDeleteClose}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteModal;